import React, { useEffect } from 'react'
import { AUTHENTICATION_SERVICE } from '../../../config/constants/env'

import AuthenticationControllerService from '../Service'

import useStyles from './Style'

const AuthenticationMonitor: React.FC = () => {
  const classes = useStyles({})

  useEffect(() => {
    function handler(event: any) {
      if (event.origin !== AUTHENTICATION_SERVICE.API_URL) {
        return
      }

      try {
        const data: { action: string } = JSON.parse(event.data)

        if (data.action === 'sign-out') {
          AuthenticationControllerService.signOut()
        }
      } catch (ex) {}
    }

    window.addEventListener('message', handler)

    return () => {
      window.removeEventListener('message', handler)
    }
  }, [])

  return (
    <iframe
      className={`${classes.iframe}`}
      height={0}
      width={0}
      src={`${AUTHENTICATION_SERVICE.API_URL}/monitor?origin=${window.location.origin}`}
    />
  )
}

export default AuthenticationMonitor
